import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { RegisterCandidate } = await import('@containers/CandidateRegistration/index');
    return {
        Component: RegisterCandidate,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
